// extracted by mini-css-extract-plugin
module.exports =  {"popper":"_2787e5dfdf--popper--KAN9G"};